let timerId: NodeJS.Timeout | null = null;

/**
 * Debounced query hook to limit the number of search requests.
 * @see https://www.algolia.com/doc/guides/building-search-ui/going-further/improve-performance/react#turn-off-search-as-you-type
 */
export function searchBoxQueryHook(query: string, search: (value: string) => void) {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), 200);
}

/**
 * This function converts attribute names to keys by trimming whitespace,
 * converting to lowercase, and replacing spaces with underscores.
 * @borrows functions\algolia-document-sync\utils\convertToKey.ts
 * @example
 * convertAttributesNameToKey("Product Category") // returns "attributes.product_category"
 */
export const convertAttributesNameToKey = (s?: string) => {
  return 'attributes.' + (s || '').trim().toLowerCase().replace(/\s+/g, '_');
};
